var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasAny
    ? _c(
        "div",
        {
          staticClass: "ai-assistant-topic-fence",
          class: {
            "ai-assistant-topic-fence--panel-compact": _vm.isPanelCompactLayout
          }
        },
        [
          _vm.topicTree.length
            ? _c(
                "div",
                {
                  ref: "topicScrollEl",
                  staticClass: "ai-assistant-topic-fence__scroll",
                  class: {
                    "ai-assistant-topic-fence__scroll--scaled":
                      _vm.topicNeedsScale,
                    "ai-assistant-topic-fence__scroll--compact":
                      _vm.isTopicLayoutCompact && !_vm.isPanelCompactLayout
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "ai-assistant-topic-fence__scale-shim",
                      class: {
                        "ai-assistant-topic-fence__scale-shim--panel-compact":
                          _vm.isPanelCompactLayout
                      },
                      style: _vm.topicScaleShimStyle
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "ai-assistant-topic-fence__scale-inner",
                          class: {
                            "ai-assistant-topic-fence__scale-inner--panel-compact":
                              _vm.isPanelCompactLayout
                          },
                          style: _vm.topicScaleInnerStyle
                        },
                        [
                          _c(
                            "div",
                            {
                              ref: "topicBoxEl",
                              staticClass: "topicBox",
                              class: {
                                "topicBox--compact": _vm.isTopicLayoutCompact,
                                "topicBox--panel-compact":
                                  _vm.isPanelCompactLayout
                              },
                              style: _vm.panelCompactTopicStyle
                            },
                            _vm._l(_vm.normalizedTopicTree, function(
                              item,
                              index
                            ) {
                              return _c(
                                "div",
                                {
                                  key: "t-" + _vm.instanceUid + "-" + index,
                                  staticClass: "topicItem"
                                },
                                [
                                  _c("div", { staticClass: "topicName" }, [
                                    _c("img", {
                                      staticClass: "topicNameImg",
                                      attrs: {
                                        src:
                                          "https://img.webloom.cn/img/aiChooseBg" +
                                          (index + 1) +
                                          ".png",
                                        alt: ""
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "topicNameTxt" }, [
                                      _vm._v(_vm._s(item.label))
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("aiNameBigTree", {
                                    key:
                                      "big-" +
                                      _vm.instanceUid +
                                      "-" +
                                      index +
                                      "-" +
                                      item.labelId,
                                    attrs: {
                                      width: _vm.aiNameBigWidth,
                                      "filter-uid":
                                        "fbt-" + _vm.instanceUid + "-" + index,
                                      fillColor1: _vm.topicColor[index * 3 + 1],
                                      fillColor2: _vm.topicColor[index * 3 + 2],
                                      fillColor3: _vm.topicColor[index * 3 + 0]
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "topicDescBox" },
                                    _vm._l(item.value, function(
                                      desc,
                                      descIndex
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key:
                                            "d-" +
                                            _vm.instanceUid +
                                            "-" +
                                            desc.labelId,
                                          staticClass: "topicDesc",
                                          class: "topicDesc" + (descIndex + 1)
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "topicDescItem" },
                                            [
                                              _c("aiNameBackground", {
                                                attrs: {
                                                  width: _vm.aiNameWidth,
                                                  fillColor:
                                                    _vm.topicColor[
                                                      index * 3 + descIndex
                                                    ]
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "topicDescLabel",
                                                  attrs: {
                                                    id: _vm.descLabelId(
                                                      index,
                                                      descIndex
                                                    )
                                                  }
                                                },
                                                [_vm._v(_vm._s(desc.label))]
                                              ),
                                              _vm._v(" "),
                                              _vm.topicRelationHas(desc.labelId)
                                                ? _c("aiChooseBorder", {
                                                    staticClass:
                                                      "topicDescBorder",
                                                    attrs: {
                                                      width: _vm.aiSecondWidth,
                                                      height: _vm.secondDescHeight(
                                                        index,
                                                        descIndex
                                                      ),
                                                      fillColor: "#ffffff"
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("aiNameTree", {
                                            staticClass: "topicDescTree",
                                            attrs: {
                                              width: _vm.aiNameTreeWidth,
                                              fillColor:
                                                _vm.topicColor[
                                                  index * 3 + descIndex
                                                ],
                                              strokeColor:
                                                _vm.topicColor[
                                                  index * 3 + descIndex
                                                ]
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "topicDescItemBox" },
                                            _vm._l(desc.value, function(
                                              value,
                                              itemIndex
                                            ) {
                                              return _c(
                                                "div",
                                                {
                                                  key:
                                                    "v-" +
                                                    _vm.instanceUid +
                                                    "-" +
                                                    value.labelId,
                                                  staticClass: "topicDescItemB",
                                                  class:
                                                    "topicDescItemB" +
                                                    (itemIndex + 1)
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "topicDescItemTxt",
                                                      style: {
                                                        color:
                                                          _vm.fontColor[
                                                            index * 3 +
                                                              descIndex
                                                          ]
                                                      },
                                                      attrs: {
                                                        id: _vm.descItemTxtId(
                                                          index,
                                                          descIndex,
                                                          itemIndex
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(value.label)
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("aiNameColor", {
                                                    staticClass:
                                                      "topicDescItemColor",
                                                    attrs: {
                                                      "filter-uid":
                                                        "fc-" +
                                                        _vm.instanceUid +
                                                        "-" +
                                                        index +
                                                        "-" +
                                                        descIndex +
                                                        "-" +
                                                        itemIndex,
                                                      width: _vm.colorBarWidth(
                                                        index,
                                                        descIndex,
                                                        itemIndex
                                                      ),
                                                      fillColor:
                                                        _vm.topicColor[
                                                          index * 3 + descIndex
                                                        ]
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _vm.topicRelationHas(
                                                    value.labelId
                                                  )
                                                    ? _c("aiChooseBorder", {
                                                        staticClass:
                                                          "topicDescItemBorder",
                                                        attrs: {
                                                          width:
                                                            _vm.colorBarWidth(
                                                              index,
                                                              descIndex,
                                                              itemIndex
                                                            ) + 15,
                                                          fillColor:
                                                            _vm.topicColor[
                                                              index * 3 +
                                                                descIndex
                                                            ]
                                                        }
                                                      })
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            }),
                                            0
                                          )
                                        ],
                                        1
                                      )
                                    }),
                                    0
                                  )
                                ],
                                1
                              )
                            }),
                            0
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.topicList.length
            ? _c("div", { staticClass: "topicTextBox" }, [
                _c("div", { staticClass: "topicTitleBox" }, [
                  _c("div", { staticClass: "topicTitleBoxItem" }, [
                    _c("div", { staticClass: "topicTitle" }, [
                      _vm._v(_vm._s(_vm.currentTopic.topicName))
                    ]),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "topicTitleImg",
                      attrs: {
                        src:
                          "https://img.webloom.cn/img/aiChooseRefuleDefault.png",
                        alt: ""
                      },
                      on: { click: _vm.clickTopicTitle }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "topicDescTxt" }, [
                  _vm._v(_vm._s(_vm.currentTopic.topicDesc))
                ])
              ])
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-2f097376", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-2f097376","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/public/ai-assistant-topic-fence.vue
// module id = null
// module chunks = 